import apiClient from './apiClient';

function filenameFromContentDisposition(disposition) {
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(disposition || '');
  const asciiMatch = /filename="([^"]+)"/i.exec(disposition || '');
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch {
      return utf8Match[1];
    }
  }
  if (asciiMatch) return asciiMatch[1];
  return null;
}

export async function listCandidateResumeOptions() {
  const { data } = await apiClient.get('/admin/candidate-resumes/options');
  return Array.isArray(data) ? data : [];
}

export async function fetchCandidateResumeAsFile(userId) {
  const res = await apiClient.get(`/admin/candidate-resumes/${userId}/resume/latest/download`, {
    responseType: 'blob',
  });

  const disposition = res.headers?.['content-disposition'] || '';
  const filename = filenameFromContentDisposition(disposition) || 'resume.pdf';

  const contentTypeHeader = res.headers?.['content-type'];
  const mimeType = contentTypeHeader?.split(';')[0]?.trim() || (/\.(docx)$/i.test(filename) ? 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' : 'application/pdf');

  const blob = res.data instanceof Blob ? res.data : new Blob([res.data], { type: mimeType || 'application/octet-stream' });
  return new File([blob], filename, { type: mimeType || 'application/octet-stream' });
}

